
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Link from "@/components/Link.vue";
import P5 from "p5";

@Component({
  components: {
    Link
  },
})

export default class Posts extends Vue{
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
    const script = function (p5: any) {    
      let speed = 2;    
      let posX = 0;
      
      p5.setup = (_:any) => {      
        const canvas = p5.createCanvas(500, 500);     
        canvas.parent("p5Canvas"); 
        p5.ellipse(p5.width / 2, p5.height / 2, 500, 500);    
      }     

      p5.draw = (_:any) => {      
        p5.background(0);
        const degree = p5.frameCount * 3;      
        const y = p5.sin(p5.radians(degree)) * 50;
          
        p5.push();
          p5.translate(0, p5.height / 2);
          p5.ellipse(posX, y, 50, 50);
        p5.pop();
        posX += speed;
            
        if (posX > p5.width || posX < 0) {    
          speed *= -1;      
        }
      }  
    }   
    new P5(script)
  }
};
